import BaseAPI, { querySuffix } from "./BaseAPI";
import { tawkRoute } from "../routes";

export default class TawkAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, tawkRoute, "tawk");
    }

    async GetAuth(targetUserID = null) {
        return this._request("get", this._url(`/auth${querySuffix({ user_id: targetUserID })}`));
    }
}
